import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthenticationModule } from '@authentication';
import { JourneyInterceptor } from './http-interceptors/journey-interceptor';
import { LanguageInterceptor } from './http-interceptors/language-interceptor';
import { JourneyService } from './services/journey.service';
import { UserAccountService } from './services/user-account.service';
@NgModule({
  imports: [BrowserModule, BrowserAnimationsModule, AuthenticationModule, HttpClientModule],
  providers: [
    UserAccountService,
    JourneyService,
    { provide: HTTP_INTERCEPTORS, useClass: JourneyInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LanguageInterceptor, multi: true }
  ],
  exports: [BrowserModule, BrowserAnimationsModule, HttpClientModule],
})
export class CoreModule {}
